import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  typography: {fontFamily: 'TIM Sans'},
  palette: {
    primary: { main: '#018ABE' },
    secondary: { main: '#018ABE'},
  }
});

export default theme;